export default {
  'research.title': 'Research',
  'research.titleHighlight': 'History',
  'research.subtitle': 'これまでの研究成果と受賞歴',

  // Awards
  'research.awards.title': 'Awards',

  // Publications
  'research.publications.title': 'Publications',
  'research.publications.international': '国際学会',
  'research.publications.domestic': '国内学会',

  // Field labels
  'research.field.venue': '会議',
  'research.field.pages': 'ページ',
  'research.field.location': '開催地',
  'research.field.authors': '著者',
};
